import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormPhoneNumber from '../general-input-form/FormPhoneNumber'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSelectInput from '../general-input-form/FormSelectInput'

const AppFormForOtherPage = ({
  values,
  handleChange,
  countryOptions,
  countryPhone,
  countryValue,
  setCountryPhone,
  handleSelectCountryPhone,
  handleSelectCountry,
  errors
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='client_name'
          name='client_name'
          colSize='6'
          inputLabel='Client Name'
          className='mb-3'
          placeholder='Enter client name...'
          value={values?.client_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.client_name}
          invalid={errors.client_name}
          autoFocus={true}
        />
        <FormTextInput 
          id='client_description'
          name='client_description'
          colSize='6'
          inputLabel='Client Description'
          className='mb-3'
          placeholder='Enter client description...'
          value={values?.client_description}
          handleTextInput={handleChange}
          feedbackInvalid={errors.client_description}
          invalid={errors.client_description}
        />
        <FormTextAreaInput
          id='client_address'
          name='client_address'
          colSize='6'
          inputLabel='Client Address'
          className='mb-3'
          placeholder='Enter client address...'
          rows='3'
          value={values?.client_address}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.client_address}
          invalid={errors.client_address}
        />
        <FormSelectInput 
          id='client_country_id'
          name='client_country_id'
          colSize='6'
          inputLabel='Country'
          className='mb-3'
          selectOptions={countryOptions}
          value={countryValue}
          handleSelectInput={handleSelectCountry}
          feedbackInvalid={errors?.client_country_id}
          invalid={errors?.client_country_id}
          disabled={false}
          placeholder='Please select country...'
        />
      </CRow>
      <CRow className="mb-4">
        <FormTextInput 
          id='pic_name'
          name='pic_name'
          colSize='6'
          inputLabel='Point of Contact (PoC) Name'
          className='mb-3'
          placeholder='Enter point of contact name...'
          value={values?.pic_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.pic_name}
          invalid={errors?.pic_name}
        />
        <FormTextInput 
          id='pic_job_position'
          name='pic_job_position'
          colSize='6'
          inputLabel='Point of Contact (PoC) Job Position'
          className='mb-3'
          placeholder='Enter point of contact job position...'
          value={values?.pic_job_position}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.pic_job_position}
          invalid={errors?.pic_job_position}
        />
        <FormPhoneNumber
          colSize='12'
          inputLabel='Point of Contact (PoC) Phone Number'
          placeholder='Enter point of contact phone number...'
          className='mb-3'
          countryOptions={countryOptions}
          country={countryPhone}
          setCountry={setCountryPhone}
          value={values}
          handlePhoneNumber={handleChange}
          handlePhoneCountry={handleSelectCountryPhone}
          errors={errors}
        />
        <FormTextInput 
          id='pic_email_address'
          name='pic_email_address'
          colSize='6'
          inputLabel='Point of Contact (PoC) Email Address'
          className='mb-3'
          placeholder='Enter point of contact email address...'
          value={values?.pic_email_address}
          handleTextInput={handleChange}
          feedbackInvalid={errors?.pic_email_address}
          invalid={errors?.pic_email_address}
        />
      </CRow>
    </>
  )
}

export default AppFormForOtherPage